import dependencyLoader from '@utils/dependencyLoader';
import { message } from '@utils/wuji-message';
import { WUJI_DEPS_KEY } from '@utils/dependencyLoader/consts';
import { presets } from '@utils/dependencyLoader/loader/preset-loader';
import { logProgress } from '@/components/dependencyModal/DependencyModal';
const useDepLoader = () => {
    let isListen = false;
    const loadDeps = async (dependencies, { signal }) => {
        const finalDependencies = dependencies.filter(i => !i.startsWith('@wuji-gogo') && !presets.includes(i));
        // 这里其实并没有真的去终止依赖的加载，但是我感觉也没必要
        if (signal.aborted) {
            message.closeAll();
            isListen = false;
            // 停止监听
            dependencyLoader.offProgress(logProgress);
            return window[WUJI_DEPS_KEY];
        }
        if (!isListen) {
            dependencyLoader.onProgress(logProgress);
            isListen = true;
        }
        await dependencyLoader.load(finalDependencies);
        return window[WUJI_DEPS_KEY];
    };
    return {
        loadDeps,
    };
};
export default useDepLoader;
